import { render } from "./PortfolioItem.vue?vue&type=template&id=42f6bfe5&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"

import "./PortfolioItem.vue?vue&type=style&index=0&id=42f6bfe5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f6bfe5"]])

export default __exports__